export const typeArray = [
  {
    event: {
      name: 'page-event',
      params: {
        id: 'id',
        categorySlug: 'payload.data.slug'
      }
    }
  },
  {
    eventCategory: {
      name: 'page-category',
      params: { id: 'id' }
    }
  },
  {
    eventAttributeKey: {
      name: 'page-attribute',
      params: { name: 'payload.data.name' }
    }
  },
  {
    place: {
      name: 'page-place',
      params: { id: 'id' }
    }
  },
  {
    placeCategory: {
      name: 'page-place-category',
      params: { id: 'id' }
    }
  },
  {
    blogPost: {
      name: 'page-blog-post',
      params: { id: 'id' }
    }
  },
  {
    blogCategory: {
      name: 'page-blog-category',
      params: { id: 'id' }
    }
  },
  {
    infoPage: {
      name: 'page-info-page',
      params: { id: 'id' }
    }
  },
  {
    infoCategory: {
      name: 'page-info-categories'
    }
  },
  {
    personalDetails: {
      name: 'page-personal-detail',
      params: { id: 'id' }
    }
  },
  {
    legalDetails: {
      name: 'page-legal-detail',
      params: { id: 'id' }
    }
  },
  {
    ticketReservation: {
      name: 'page-orders-event',
      query: { t_id: 'id' }
    }
  },
  {
    hotelReservation: {
      name: 'page-orders-booking',
      query: { t_id: 'id' }
    }
  },
  {
    city: {
      name: 'page-city',
      params: {
        id: 'id'
      }
    }
  },
  {
    page: {
      name: 'page-page',
      params: { id: 'id' }
    }
  },
  {
    hotel: {
      name: 'page-hotel',
      params: { id: 'id' }
    }
  },
  {
    guide: {
      name: 'page-guide',
      params: { id: 'id' }
    }
  },
  {
    touristAgency: {
      name: 'page-tourist-agency',
      params: { id: 'id' }
    }
  },
  {
    eventOrganizer: {
      name: 'page-event-organizer',
      params: { id: 'id' }
    }
  },
  {
    route: {
      name: 'page-route',
      params: { id: 'id' }
    }
  },
  {
    routePoint: {
      name: 'page-route',
      params: { id: 'payload.data.routeId' }
    }
  },
  {
    audioguide: {
      name: 'page-audioguide',
      params: { id: 'id' }
    }
  },
  {
    audioguidePoint: {
      name: 'page-audioguide',
      params: { id: 'payload.data.audioguideId' }
    }
  },
  {
    historicalFigures: {
      name: 'page-historical-figure',
      params: { id: 'id' }
    }
  },
  {
    culturalOrganization: {
      name: 'page-cultural-organization',
      params: { id: 'id' }
    }
  },
  {
    account: {
      name: 'page-account',
      params: { id: 'id' }
    }
  },
  {
    role: {
      name: 'page-role',
      params: { id: 'id' }
    }
  },
  {
    sharedAccess: {
      name: 'page-shared-access',
      query: {
        t_id: 'id'
      }
    }
  },
  {
    kiosk: {
      name: 'page-kiosk-device',
      params: { id: 'id' }
    }
  },
  {
    stream: {
      name: 'page-stream',
      params: { id: 'id' }
    }
  },
  {
    adPlacement: {
      name: 'page-ad-placement',
      params: { id: 'id' }
    }
  },
  {
    file: {
      name: 'page-media-library',
      query: { t_id: 'id' }
    }
  },
  {
    dictionary: {
      name: 'page-dictionary',
      params: { id: 'id' }
    }
  },
  {
    seoConfig: {
      name: 'page-seo-config',
      params: { id: 'id' }
    }
  },
  {
    auth: {
      name: 'page-account',
      params: { id: 'id' }
    }
  }
]
